import { apiPost } from "./api";
import { getRecaptchaToken } from "./recaptcha";

export interface B2bEnquiry {
  companyName: string;
  businessType: string;
  estimatedMonthlyVolume: string;
  deliveryCity: string;
  contactEmail: string;
  rfqDocumentName?: string;
}

/**
 * Routes a B2B enquiry to Corporate Sales: mints a reCAPTCHA v3 token, then POSTs to the
 * real `/api/public/enquiries/b2b` endpoint (verifies the token, writes the enquiry to
 * Firestore, returns a server-issued reference number) — same pattern as
 * supplierEnquiry.ts. No client-side simulation. (This is the marketing-site B2B enquiry
 * form at /partnerships; not to be confused with the admin panel's B2B & bulk orders screen,
 * `pages/admin/AdminBulkOrders`, which is a separate, staff-only order-capture system.)
 */
export async function submitB2bEnquiry(enquiry: B2bEnquiry): Promise<{ ok: true; referenceNumber: string }> {
  const recaptchaToken = await getRecaptchaToken("b2b_enquiry");
  return apiPost<{ ok: true; referenceNumber: string }>("/public/enquiries/b2b", {
    ...enquiry,
    recaptchaToken,
  });
}
